import * as React from "react"

export function useHubSpotForm({
  callback,
  formCreated,
  formId,
  loaded,
  portalId,
  redirectUrl,
}) {
  React.useEffect(() => {
    if (window && portalId) {
      const windowWithHubSpot = window

      if (loaded && windowWithHubSpot.hbspt && !formCreated) {
        const target = `[data-hubspot-forms-id='${formId}']`

        windowWithHubSpot.hbspt.forms.create({
          formId,
          portalId,
          redirectUrl,
          target,
        })

        callback()
      }
    }
  }, [callback, formCreated, formId, loaded, portalId, redirectUrl])
}
